export const environment = {
    production: false,
    version: require('../../package.json').version,
    versionDate: require('../../package.json').versionDate,
    envt: 'QA',    
    authority : 'https://login.microsoftonline.com/ceb177bf-013b-49ab-8a9c-4abce32afc1e',
    client_Id : '2bce10b0-00ff-46bf-bb29-f62dbc0a5809',
    graphEndPoint : 'https://graph.microsoft.com/v1.0/me',
    claimUrl : 'http://schemas.cat.com/identity/claims/catloginid',
    logoutRedirectUrl : 'http://localhost:4200/',
    scopesUserRead : 'user.read',
    scopesOpenid :'openid',
    scopesProfile : 'profile',
    redirectUrl : window.location.origin + '/response-oidc',
    oauth: true,
    ApiUrl:"https://suppliergwqa.solar.cat.com/api",
    QRApiUrl: "https://qrqa.solar.cat.com",
    AuthId : '',
    CwsLogoutUrl: "https://login.cat.com/CwsLogin/cws/logout.htm",
    sessionInitiatelURL:"https://suppliergwqa.solar.cat.com/home"
  };
